import Ship from './ship.js';

export default class Carrier extends Ship {
  constructor() {
    super(5, 'carrier');
  }
}
